// Extracts the portal-api error code (e.g. `payment_failed`) from a refine HttpError.
// Nest BadRequestException('code') yields body.message = 'code'; some filters use body.error.
const KNOWN_CODES = [
    'payment_failed',
    'no_default_card',
    'package_not_found',
    'balance_unavailable',
    'auto_recharge_disabled_by_admin',
    'cap_above_admin_max',
    'cap_below_package_price',
    'package_below_threshold',
];

export const getSmsCreditsErrorCode = (error: unknown): string | undefined => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- axios error shape is untyped
    const body = (error as any)?.response?.data;
    const candidates: unknown[] = [body?.message, body?.error, (error as Error)?.message].flat();
    return candidates.find((c): c is string => typeof c === 'string' && KNOWN_CODES.includes(c));
};
